export default "__VITE_PUBLIC_ASSET__b14d752d__"